import { NexTable } from "../../components/Table/NexTable"
import { MeasureConversion, TableColumn } from "../../models/Table"
import { FlightPlannedLineType } from "../../store/types/FlightPlansTypes"
import { useFlightplanEditStore } from "../../zstore/FlightplanEditStore"

const flightplanTablePrimaryKey: keyof FlightPlannedLineType = "planned_line_id"

const columns: TableColumn<FlightPlannedLineType>[] = [
    { id: "flight_line_name", label: "Line ID", align: "right", minWidth: 120, width: "22%" },
    {
        id: "planned_distance",
        label: "Distance\u00a0",
        align: "right",
        minWidth: 100,
        width: "22%",
        convertType: MeasureConversion.DISTANCE,
    },
    { id: "node_count", label: "Node Count" },
    {
        id: "mission_name",
        label: "Flown Mission ID",
        align: "center",
        minWidth: 190,
        width: "56%",
    },
]

export const FlightplanTable = () => {
    const selectedFlightplan = useFlightplanEditStore((state) => state.selectedFlightplan)
    const flightPlannedLines = useFlightplanEditStore((state) => state.selectedFlightplanPlannedLines)
    const updatePlannedLines = useFlightplanEditStore((state) => state.updatePlannedLines)
    const { status } = selectedFlightplan

    const filteredRows = flightPlannedLines.filter((fl) => (status === "Complete" ? Boolean(fl.mission_name) : true)) // filter out unflown lines if Complete

    const handleUpdate = async (lines: FlightPlannedLineType[], changed: FlightPlannedLineType[] = []) => {
        await updatePlannedLines(
            lines,
            changed.map((line) => line.planned_line_id),
        )
    }

    return (
        <NexTable
            label="Flightplan Lines"
            columns={columns}
            rows={filteredRows}
            primaryKey={flightplanTablePrimaryKey}
            updateTableRows={handleUpdate}
            tableRowOptions={{ canSelectRow: (row: FlightPlannedLineType) => !row.mission_name }}
            maxHeight={600}
            canSelect
            canDeleteSelected
        />
    )
}
